export const isDevBox = (): boolean => process.env.REACT_APP_IS_DEV_BOX === 'true';
export const isDevEnvironment = (): boolean => process.env.REACT_APP_ENV === 'development';
export const isTestEnvironment = (): boolean => process.env.REACT_APP_ENV === 'test';
export const isStagingEnvironment = (): boolean => process.env.REACT_APP_ENV === 'staging';
export const isProdEnvironment = (): boolean => process.env.REACT_APP_ENV === 'production';
export const getEnvironment = (): string => process.env.REACT_APP_ENV || 'development';
